import { HttpError, OpenNotificationParams } from '@refinedev/core';
import { isAxiosError } from 'axios';

export const formatError = (
  error?: HttpError,
  description?: string,
): OpenNotificationParams => {
  let message = '';

  if (isAxiosError(error) && error.response?.data.message) {
    message = error.response?.data.message;
  } else if (error?.message) {
    message = error.message;
  }

  return {
    message,
    description,
    type: 'error',
  };
};

export const formatSuccess = (message: string): OpenNotificationParams => {
  return {
    message,
    type: 'success',
  };
};
